// extracted by mini-css-extract-plugin
export default {"btnOrange":"CourseDetails_btnOrange__WNMQA"};